import { createReducer, on } from '@ngrx/store';

import { RequestStatus } from '@patient-ui/shared/enums';
import { FastRegistrationVerifyResponse } from '@patient-ui/shared/models';

import { FastRegistrationActions } from './fast-registration.actions';

export const fastRegistrationFeatureKey = 'fastregistration';

export interface FastRegistrationState {
  fastRegistrationPatient: FastRegistrationVerifyResponse;
  serviceUnavailable: boolean;
  verifyFastRegistrationRequestStatus: RequestStatus;
  verifyFastRegistrationRequestError: string;
  verifyFastRegistrationFirstName: string;
  verifyFastRegistrationLastName: string;
  verifyFastRegistrationUserid: string;
  submitFastRegistrationRequestStatus: RequestStatus;
  submitFastRegistrationRequestError: string;
  submitFastRegistrationFirstName: string;
  submitFastRegistrationLastName: string;
  submitFastRegistrationUserid: string;
  source: string;
  redirectUrl: string;
}

export const initialState: FastRegistrationState = {
  fastRegistrationPatient: {
    hashId: '',
    mdmHashId: '',
    emailId: '',
  },
  serviceUnavailable: false,
  verifyFastRegistrationRequestStatus: RequestStatus.NotSent,
  verifyFastRegistrationRequestError: '',
  verifyFastRegistrationFirstName: '',
  verifyFastRegistrationLastName: '',
  verifyFastRegistrationUserid: '',
  submitFastRegistrationRequestStatus: RequestStatus.NotSent,
  submitFastRegistrationRequestError: '',
  submitFastRegistrationFirstName: '',
  submitFastRegistrationLastName: '',
  submitFastRegistrationUserid: '',
  source: '',
  redirectUrl: '',
};

export const fastRegReducer = createReducer(
  initialState,
  on(FastRegistrationActions.VerifyFastRegistration, (state, { payload }) => ({
    ...state,
    verifyFastRegistrationRequestStatus: RequestStatus.Pending,
    verifyFastRegistrationFirstName: '',
    verifyFastRegistrationLastName: '',
    verifyFastRegistrationUserid: '',
    source: payload.source || '',
  })),
  on(
    FastRegistrationActions.VerifyFastRegistrationSuccess,
    (state, { response }) => ({
      ...state,
      fastRegistrationPatient: response,
      verifyFastRegistrationRequestStatus: RequestStatus.Success,
    })
  ),
  on(
    FastRegistrationActions.VerifyFastRegistrationFailure,
    (state, { payload }) => ({
      ...state,
      verifyFastRegistrationRequestError: payload.error,
      verifyFastRegistrationFirstName: payload.firstName || '',
      verifyFastRegistrationLastName: payload.lastName || '',
      verifyFastRegistrationUserid: payload.userid || '',
      verifyFastRegistrationRequestStatus: RequestStatus.Failure,
    })
  ),
  on(FastRegistrationActions.SubmitFastRegistration, (state) => ({
    ...state,
    submitFastRegistrationRequestStatus: RequestStatus.Pending,
    submitFastRegistrationFirstName: '',
    submitFastRegistrationLastName: '',
    submitFastRegistrationUserid: '',
  })),
  on(
    FastRegistrationActions.SubmitFastRegistrationSuccess,
    (state, { response }) => ({
      ...state,
      fastRegistrationPatient: response,
      submitFastRegistrationRequestStatus: RequestStatus.Success,
    })
  ),
  on(
    FastRegistrationActions.SubmitFastRegistrationFailure,
    (state, { payload }) => ({
      ...state,
      submitFastRegistrationRequestError: payload.error,
      submitFastRegistrationFirstName: payload.firstName || '',
      submitFastRegistrationLastName: payload.lastName || '',
      submitFastRegistrationUserid: payload.userid || '',
      submitFastRegistrationRequestStatus: RequestStatus.Failure,
    })
  ),
  on(FastRegistrationActions.ClearFastRegistrationState, () => ({
    ...initialState,
  })),
  on(FastRegistrationActions.SetRedirectUrl, (state, { redirectUrl }) => ({
    ...state,
    redirectUrl: redirectUrl,
  }))
);
